/**
 * ライセンスタイプ
 */
export var LicenseTypes;

(function (LicenseTypes) {
  /**
   * 無償
   */
  LicenseTypes[LicenseTypes["Free"] = 0] = "Free";
  /**
   * 有償
   */

  LicenseTypes[LicenseTypes["Paid"] = 1] = "Paid";
})(LicenseTypes || (LicenseTypes = {}));